import React, { useEffect, useRef, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CommonGrid from '../../Repository/CommonGrid';
import { useDispatch } from 'react-redux';
import { api } from '../../../redux/api';
import { Loader } from '../../../utils/loader';

const SQLQueryPreview = ({ open, close, queryAccount, connection, schema, sqlQueryToRun }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [gridOptions, setGridOptions] = useState({});
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [copyButtonText, setCopyButtonText] = useState(`${t('MNU_COPY')} ${t('LBL_ERR')}`);

    const updateNewGridOptions = (data) => {
        const columns = data?.length > 0 ? data[0] : [];
        const options = {
            columnDefs: columns?.map(column => ({
                headerName: column,
                field: column
            }))
        }
        setGridOptions(options);

        const rowData = data.slice(1, 500).map(row => {
            const rowDataObj = {};
            columns.forEach((column, index) => {
                rowDataObj[column] = row[index];
            });
            return rowDataObj;
        });
        setRowData(rowData);
    }

    const getQueryResult = () => {
        setLoading(true);
        dispatch(api.endpoints.get_sql_result.initiate({
            account: queryAccount,
            direction: "OUT",
            pdc_name: connection,
            encoding: 'DEFAULT_ENCODING',
            schema: schema,
            body: {
                sqlQueryToRun: sqlQueryToRun,
            }
        }, { forceRefetch: true }))
            .then((res) => {
                if (res?.data?.current_state === 'SUCCESS') {
                    if (!res?.data?.data?.includes(t('DB_NAV_SQL_VERIFIED_ERRORS'))) updateNewGridOptions(res?.data?.data);
                    setLoading(false);
                }
                if (res?.data?.current_state === 'ERROR') {
                    setRowData([]);
                    setGridOptions({});
                    setError(res?.data?.message);
                    setLoading(false);
                }
            });
    }

    const handleCopyError = () => {
        if (error) {
            navigator.clipboard.writeText(error)
                .then(() => {
                    setCopyButtonText('Copied');
                    setTimeout(() => setCopyButtonText(`${t('MNU_COPY')} ${t('LBL_ERR')}`), 5000);
                })
                .catch(err => {
                    console.error('Failed to copy: ', err);
                });
        }
    };

    useEffect(() => {
        if (open) {
            getQueryResult();
        }
        return () => { setError('') }
    }, [open])

    return (
        <>
            <Dialog
                open={open}
                fullWidth={true}
                maxWidth={"lg"}>
                <DialogTitle style={{ borderBottom: "1px solid #e0e0e0" }}>
                    <div className="title">{t("LBL_DATABASE_RECORDS")}</div>
                </DialogTitle>
                <DialogContent dividers
                    className="dialog-content"
                    sx={{ boxSizing: "border-box", height: "100vh", overflow: "hidden" }}
                >
                    {
                        (loading || !gridOptions) ? <Loader /> : <Box className="div-textBox-action" sx={{ height: '100%' }}>
                            {rowData?.length !== 0 ? <CommonGrid
                                gridOptions={gridOptions}
                                rowData={rowData}
                                containerStyle={{ height: "100% !important" }}
                            /> : <Typography className="panel-no-data" sx={{ wordBreak: 'break-word', whiteSpace: 'normal', color: "red", userSelect: 'text' }} variant="body2">{error}</Typography>}
                        </Box>
                    }
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'space-between' }}>
                    <Typography variant="body1">
                        {`${rowData?.length} ${t('LBL_RECORDS_RETURNED')}`}
                    </Typography>
                    <Box>
                        {error !== '' && <Button variant="outlined" size="small" onClick={handleCopyError}>
                            {copyButtonText}
                        </Button>}
                        <Button variant="outlined" sx={{ ml: '20px' }} size="small" onClick={close}>
                            {t("BTN_DONE")}
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default SQLQueryPreview